import colorShade from "../../utils/colorShade";
import dayjsTZ from "../../utils/dayjs";

const colDefs = ({
  navigate,
  isMobileView,
  renderConditions,
  mode,
  accentColor,
}) =>
  [
    {
      headerName: "ID e punonjesit",
      field: "employeeId",
      hide: true,
    },
    {
      headerName: "Punonjësi",
      field: "employeeFullName",
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 2,
      sort: "asc",
      mobile: true,
      isCollapseTitle: true,
      isExported: true,
      cellClickKey: "employeeId",
      // valueGetter: ({ data }) => data?.employeeFullName,
      onCellClick: ({ clickId }) =>
        navigate(`/punonjesit/specifikat/${clickId}`),
      ...(!isMobileView
        ? {
            cellRenderer: function ({ data }) {
              try {
                return (
                  <div
                    className="navigate-row"
                    onClick={() => {
                      navigate(`/punonjesit/specifikat/${data?.employeeId}`);
                    }}
                    style={
                      mode.includes("dark")
                        ? { color: "#FFF" }
                        : { color: colorShade(accentColor, 0.25) }
                    }
                  >
                    {data?.employeeFullName}
                  </div>
                );
              } catch (err) {
                if (data?.employeeFullName) {
                  return data?.employeeFullName;
                } else {
                  return null;
                }
              }
            },
          }
        : {}),
    },
    {
      headerName: "Departamenti",
      field: "employeeDepartmentName",
      filter: "agTextColumnFilter",
      flex: 3,
      resizable: true,
      mobile: true,
      isExported: true,
      //can be done
      // cellClickKey: "employeeDepartmentId",
      // onCellClick: ({ clickId }) =>
      //   navigate(`/dep/${clickId}`),
      onCellClick: () => navigate(`/departamentet`),
    },
    {
      headerName: "Dega",
      field: "employeeTeam",
      filter: "agTextColumnFilter",
      flex: 3,
      resizable: true,
      mobile: true,
      isExported: true,
    },
    {
      headerName: "Roli",
      field: "employeeRoleName",
      filter: "agTextColumnFilter",
      flex: 2.5,
      resizable: true,
      mobile: true,
      isExported: true,
      isCollapseTitle: true,
      onCellClick: () => navigate(`/departamentet`),
    },
    {
      headerName: "Role të tjera",
      field: "employeeOtherPosition",
      filter: "agTextColumnFilter",
      flex: 2.5,
      resizable: true,
      isExported: true,
      // Concatenate the array so text-based filter + CSV export both work.
      valueGetter: ({ data }) =>
        Array.isArray(data?.employeeOtherPosition)
          ? data.employeeOtherPosition.join(", ")
          : data?.employeeOtherPosition || "",
      cellRenderer: ({ data }) => {
        const others = Array.isArray(data?.employeeOtherPosition)
          ? data.employeeOtherPosition
          : [];
        if (!others.length) return "—";
        return others.join(", ");
      },
    },
    {
      headerName: "Email punës",
      field: "employeeEmailWork",
      filter: "agTextColumnFilter",
      flex: 2.5,
      resizable: true,
      mobile: true,
      isExported: true,
    },
    {
      headerName: "Data Punësimit",
      field: "employeeHireDate",
      filter: "agDateColumnFilter",
      resizable: true,
      flex: 2,
      mobile: true,
      isExported: true,
      format: "DD/MM/YYYY",
      valueFormatter: ({ node, value }) =>
        node.group && value
          ? dayjsTZ(value).format("DD/MM/YYYY")
          : value
          ? dayjsTZ(value).format("DD/MM/YYYY")
          : "",
      keyCreator: ({ value }) =>
        value ? dayjsTZ(value).format("DD/MM/YYYY") : "",
      //value for filtering
      valueGetter: ({ data }) =>
        data?.employeeHireDate ? dayjsTZ(data.employeeHireDate).toDate() : null,
      //value for displaying
      cellRenderer: ({ data }) =>
        data?.employeeHireDate
          ? dayjsTZ(data.employeeHireDate).format("DD/MM/YYYY")
          : "",
      filterParams: {
        apply: true,
        newRowsAction: "keep",
        inRangeInclusive: true,
      },
    },
    {
      headerName: "Data Përfundimit",
      field: "employeeContractEndDate",
      filter: "agDateColumnFilter",
      resizable: true,
      flex: 2,
      mobile: true,
      isExported: true,
      format: "DD/MM/YYYY",
      valueFormatter: ({ node, value }) =>
        node.group && value
          ? dayjsTZ(value).format("DD/MM/YYYY")
          : value
          ? dayjsTZ(value).format("DD/MM/YYYY")
          : "",
      keyCreator: ({ value }) =>
        value ? dayjsTZ(value).format("DD/MM/YYYY") : "",
      //value for filtering
      valueGetter: ({ data }) =>
        data?.employeeContractEndDate
          ? dayjsTZ(data.employeeContractEndDate).toDate()
          : null,
      //value for displaying
      cellRenderer: ({ data }) =>
        data?.employeeContractEndDate
          ? dayjsTZ(data.employeeContractEndDate).format("DD/MM/YYYY")
          : "",
      filterParams: {
        apply: true,
        newRowsAction: "keep",
        inRangeInclusive: true,
      },
    },
    {
      headerName: "Lloji i punësimit",
      field: "employeeTypeOfEmployment",
      filter: "agTextColumnFilter",
      flex: 2.5,
      isExported: true,
      resizable: true,
      hide: true,
    },
    {
      headerName: "createdAt",
      field: "createdAt",
      filter: "agDateColumnFilter",
      flex: 2.5,
      resizable: true,
      hide: true,
      format: "DD/MM/YYYY",
      valueGetter: ({ data }) =>
        !!data?.createdAt ? dayjsTZ(data.createdAt).format("DD/MM/YYYY") : null,
      filterParams: {
        apply: true,
        newRowsAction: "keep",
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          if (!cellValue) return 0;

          const [day, month, year] = cellValue.split("/").map(Number);
          const cellDate = new Date(year, month - 1, day);

          if (cellDate < filterLocalDateAtMidnight) return -1;
          if (cellDate > filterLocalDateAtMidnight) return 1;
          return 0;
        },
        browserDatePicker: true,
      },
    },
    // {
    //   headerName: "Emri",
    //   field: "employeeFirstName",
    //   filter: "agTextColumnFilter",
    //   flex: 2.5,
    //   resizable: true,
    //   hide: true,
    // },
    // {
    //   headerName: "Mbiemri",
    //   field: "employeeLastName",
    //   filter: "agTextColumnFilter",
    //   flex: 2.5,
    //   resizable: true,
    //   hide: true,
    // },
    {
      headerName: "Status",
      field: "employeeStatus",
      hide: true,
      isExported: true,
    },
  ].map((el) => ({
    ...el,
    hide: el.hasOwnProperty("hide") ? el.hide : renderConditions?.[el?.field],
    ...(el.hasOwnProperty("mobile")
      ? renderConditions.hasOwnProperty(el?.field)
        ? { mobile: !renderConditions?.[el?.field] }
        : { mobile: el.mobile }
      : {}),
  }));

export default colDefs;
